const Header = {


	init: function () {
		const header = document.querySelector('header.header');
		const mobileMenu = header.querySelector('.mobile-menu');
		const menu = header.querySelector('.menu-level-1');

		if (!mobileMenu || !menu) {
			return;
		}

		mobileMenu.addEventListener('click', () => {
			mobileMenu.classList.toggle('open');
			menu.classList.toggle('open');
		});

		let lastKnownScrollY = 0;
		let ticking = false;

		const toggleClass = (scrollY) => {
			if (scrollY >= 512) {
				header.classList.add('scrolled');
			} else {
				header.classList.remove('scrolled');
			}
		};

		const onScroll = () => {
			lastKnownScrollY = window.scrollY || window.pageYOffset;
			if (!ticking) {
				window.requestAnimationFrame(() => {
					toggleClass(lastKnownScrollY);
					ticking = false;
				});
				ticking = true;
			}
		};

		toggleClass(window.scrollY || window.pageYOffset);
		window.addEventListener('scroll', onScroll, {passive: true});
	},


};

export default Header;
